export default "__VITE_ASSET__C0h22sA2__"